import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { FormFieldText } from "@/components/FormFields/FormFieldText/FormFieldText";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";
import { type FormFieldComponentProps } from "@/lib/types/types";

interface PassedProps {
  explanation?: JSX.Element;
  label?: JSX.Element;
}

export const MemberIdComponent = ({
  value,
  isErrored,
  onChange,
  explanation,
  placeholder = "",
  isRequired = false,
  label,
  disabled = false,
}: FormFieldComponentProps & PassedProps) => {
  const { msg } = useMessage();
  const getDefaultExplanation = () =>
    !isRequired ? <FormattedHTMLMessage id="optional" defaultMessage="Optional" /> : "";

  const isFieldHidden = getFieldConfigByFieldId("memberId")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="member-id"
      refId="memberId"
      value={value}
      onChange={onChange}
      placeholder={placeholder || msg({ id: "memberIdPlaceholder" })}
      label={label || <FormattedHTMLMessage id="memberId" defaultMessage="ID Number" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidMemberId" defaultMessage="Invalid ID Number" />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      explanation={explanation || getDefaultExplanation()}
      required={isRequired}
      disabled={disabled}
    />
  );
};
